var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('MainPage',{attrs:{"withArticles":false,"withEvents":false}},[_c('div',{staticClass:"memories-page"},[_c('div',{staticClass:"page-wrapper"},[_c('MemoryForm')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }